/**
 * Strips timestamp off the bsid
 * @param {string} sessionId
 */
export function parseSessionId(sessionId) {
    if (typeof sessionId === 'string') {
        return sessionId.replace(/_.*$/, '');
    }
}
